let fullText; // variable to hold the full text
let shortText; // variable to hold the short version of the text 

$w.onReady(function () {
// how many characters to include in the shortened version
const shortTextLength = 260;  // you can change this number
// read the full text and store it in the fullText variable
fullText = $w("#text134").text;
// grab the number of characters defined in shortTextLength and store them in the shortText variable
shortText = fullText.substr(0, shortTextLength) + "...";
// set the contents of the text element to be the short text
$w("#text134").text = shortText;
});

export function button13_click(event, $w) { //make sure you have added the onClick event in properties
// display the full text
$w("#text134").text = fullText;
// collapse the button
$w("#button13").collapse();
}

